<template>
  <div>
    <div class="query__div" @keydown.enter="submit">
      <div @dblclick="dblclick('code')" class="flex items-center">
        <slot name="label"></slot>
        <el-input maxlength='450' v-model="query.code" :placeholder="ph" style="margin-right: 20px; width: 250px"
          ref="ScanQueryIpt" @dblclick="dblclick('code')" :disabled="disabled || disabled2" @input="(e) => $emit('input', e)"/>
      </div>
      <slot name="form"></slot>
      <el-button icon="el-icon-search" type="primary" style="margin-right: 8px;" @click="submit" :disabled="disabled">{{ keyText || '查询' }}
      </el-button>
      <el-button v-if="showRest" type="default" @click="rest" style="margin-left:0px;margin-right: 20px;height: 34px;width: 72px;" :disabled="disabled">重置</el-button>
      <el-checkbox v-if="!!print" v-model="query.isPrint" :disabled="disabled">打印</el-checkbox>
      <slot></slot>
      <div style="margin-left: auto">
        <slot name="customize"></slot>
      </div>
    </div>
    <BatchSearchDialog ref="batchSearchDialog" @search="batchSearch" @batchClose="batchClose" :max="100"/>
  </div>
</template>

<script>
import BatchSearchDialog from '@/components/BatchSearchDialog/index.vue'
export default {
  name: "ScanQuery",
  components:{BatchSearchDialog},
  props: {
    ph: String,
    print: Boolean,
    isRetain: Boolean,//保留输入框内信息
    keyText: String,
    batchPanel:{
      type: Boolean,
      default:false
    },
    showRest: {
      type: Boolean,
      default: (_) => {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default: (_) => {
        return false;
      },
    },
    disabled2: {
      type: Boolean,
      default: (_) => {
        return false;
      },
    },

  },
  emits: ['input'],
  data() {
    return {
      query: {
        code: '',
        isPrint: !!this.print
      }
    }
  },
  mounted() {
    setTimeout(_ => {
      this.$refs['ScanQueryIpt'].focus()
    }, 100)
  },
  methods: {
    submit: function () {
      // if(!this.query.code){
      //   return;
      // }
      const { code, isPrint } = this.query
      this.query = {
        code: this.isRetain ? this.query.code : '',
        isPrint
      }

      this.$refs['ScanQueryIpt'].focus()

      this.$emit('onQuery', {
        code, isPrint
      })
    },
    rest() {
      this.query.code=''
      this.$emit('rest')
    },
    focusIpt(preventScroll = false) {
      //直接focus到内部的input
      if(preventScroll){
        this.$refs['ScanQueryIpt'].$el.children[0].focus({
          preventScroll: true
        })
        return 
      }
      this.$refs['ScanQueryIpt'].focus()
    },
    focusBlur(){
      this.$refs['ScanQueryIpt'].blur()
    },
    dblclick(key) {
      if(this.disabled){
        return 
      }
      this.batchPanel && this.$refs.batchSearchDialog.open({ key })
    },
    batchSearch(params) {
      console.log(params)
      this.query = {
        ...this.query,
        ...params
      }
      this.submit()
    },
    batchClose(){
      this.$refs['ScanQueryIpt'].focus()
    }
  }
}
</script>

<style scoped>
.query__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
}

.flex{
  display: flex;
}

.items-center{
  align-items: center;
}
</style>
